import React from "react";
import { STATUS_COLORS, getPaletteColor } from "../../../utils/chartTheme";
import { formatCount } from "../../../utils/numberFormat";

// Activity Type Card Component
const ActivityTypeCard = ({ title, count, variant = "default" }) => {
  const borderColors = {
    default: "#ededed",
    completed: STATUS_COLORS.completed,
    inProgress: STATUS_COLORS.underConstruction,
    cancelled: getPaletteColor(2),
  };

  const borderColor = borderColors[variant] || borderColors.default;

  return (
    <div>
      <div
        className="bg-[#f7f7f7] text-white h-28 p-2.5 rounded-3xl border-2 hover:border-teal-300 transition-all duration-300 hover:shadow-md"
        style={{ borderColor }}
      >
        <h3 className="text-2xl text-center mt-4 mb-0 text-[#3A3A3A] p-0 font-bold text-balance">
          {count !== undefined && count !== null ? count : 0}
        </h3>
        <h6 className="text-xs text-center p-0 m-0 text-[#787878] font-semibold">
          {title}
        </h6>
      </div>
    </div>
  );
};

const ImplementationSummary = ({ data, loading }) => {
  if (loading) {
    return (
      <div className="text-center">
        <h3 className="text-xl my-2 p-0 text-[#3A3A3A] font-bold uppercase mb-4 text-balance">
          Implementation Summary (0)
        </h3>
        <div className="grid grid-cols-3 gap-3">
          {[1, 2, 3].map((i) => (
            <div
              key={i}
              className="bg-gray-100 rounded-3xl h-28 animate-pulse"
            ></div>
          ))}
        </div>
      </div>
    );
  }


  const getImplementationCounts = () => {
    const detailed = data?.statusDistribution?.detailed || {};

    const completed = detailed["Completed"]?.count || 0;
    const inProgress = detailed["In Progress"]?.count || 0;
    const cancelled = detailed["Cancelled / Excluded"]?.count || 0;

    const calculatedTotal = completed + inProgress + cancelled;
    const totalFromAPI = data?.overallStatus?.totalImplementations || 0;
    const total = totalFromAPI > 0 ? totalFromAPI : calculatedTotal;

    return {
      completed: completed,
      inProgress: inProgress,
      cancelled: cancelled,
      total: total,
    };
  };

  const counts = getImplementationCounts();
  const totalFormatted = formatCount(counts.total);

  return (
    <div className="text-center">
      <h3 className="text-xl my-2 p-0 text-[#3A3A3A] font-bold uppercase text-balance">
        Implementation Summary ({totalFormatted})
      </h3>
      <div className="grid grid-cols-3 gap-3">
        <ActivityTypeCard
          title="Completed"
          count={formatCount(counts.completed)}
          variant="completed"
        />
        <ActivityTypeCard
          title="In Progress"
          count={formatCount(counts.inProgress)}
          variant="inProgress"
        />
        <ActivityTypeCard
          title="Cancelled"
          count={formatCount(counts.cancelled)}
          variant="cancelled"
        />
      </div>
    </div>
  );
};

export default ImplementationSummary;
